import {fetchMenu, fetchMonitorServer} from '../services/menu';
import {openErrorDialog} from '../components/commons/ScheduleDialog';
import {routerRedux} from 'dva/router';
import pathToRegexp from 'path-to-regexp';
import {CHINESE, ENGLISH, PATH_HOME, PATHS, RES_STATUS} from '../utils/constants';
import logoImg from '../assets/visical-logo-name.png';
import * as i18n from '../i18n';

export default {
  namespace: 'menu',
  state: {
    pathname: PATH_HOME,
    menus: [],
    domainBgImage: '',
    domainI18nLogoZH: '',
    domainI18nLogoEN: '',
    sysNameZH:'',
    sysNameEN:'',
    minitorServer:'',
    search:'',
    inlineCollapsed:false
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    setMenus(state, { menus }) {
      return { ...state, menus };
    },
    updatePathname(state, { pathname }) {
      return { ...state, pathname };
    },
    updateSearch(state, {search}){
      return { ...state, search };
    },
    updateLogoBg(state, { logoBg }) {
      const { domainI18nLogoZH, domainI18nLogoEN } = logoBg;
      if (!domainI18nLogoZH && !domainI18nLogoEN) {
        logoBg.domainI18nLogoZH = logoImg;
        logoBg.domainI18nLogoEN = logoImg;
      }
      return { ...state, ...logoBg };
    },
    updateSysName(state, {sysName}) {
      const {sysNameEN, sysNameZH} = sysName;
      sysName.sysNameEN = sysNameEN ? sysNameEN : i18n[ENGLISH]["index_reservation_platform"];
      sysName.sysNameZH = sysNameZH ? sysNameZH : i18n[CHINESE]["index_reservation_platform"];
      return {...state, ...sysName};
    }
  },
  effects: {
    *getMenu({ pathname }, { call, put, select }) {
      const token =
        (yield select(state => state.login.token)) ||
        sessionStorage.getItem('token');
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { messages } = yield select(state => state.i18n);
      pathname = pathname
        ? pathname
        : yield select(state => state.menu.pathname);
      const { data: menus = [], status, msg } = yield call(fetchMenu, {
        token,
        locale
      });
      if (!token) {
        yield call(openErrorDialog, { message: messages['user_not_login'] });
      } else if (status !== RES_STATUS.success) {
        yield call(openErrorDialog, { message: msg });
      } else {
        const { valid, forbidden } = matchPath(pathname, menus);
        if (!valid || forbidden) {
          yield put(routerRedux.push(PATH_HOME));
        } else {
          yield put({ type: 'setMenus', menus: { data: menus, status, msg } });
        }
      }
    },
    *getMonitorServer(_, { put, select, call }) {
      const locale = yield select(state => state.i18n.locale) || 'zh_CN';
      const { data, status } = yield call(fetchMonitorServer, {locale});
      if (status === 0 && data) {
        yield put({ type: 'update', payload: { minitorServer: data } });
      }
    },
    *shiftLanguage({ locale }, { put, select }) {
      const { pathname,search } = yield select(state => state.menu);
      yield put({ type: 'i18n/setLocale', locale: locale });
      yield put({ type: 'getMenu', pathname });
      yield put(routerRedux.replace(`${pathname}${search}`));
    },
    *redirectForParentPath({ pathname }, { put, select, take }) {
      //因为不确定当前用户的角色有什么菜单，所以点击父级菜单菜单时需要一次重定向
      const { userInfo } = yield select(state => state.login);
      let redirectPath = PATHS.blank;
      yield put({ type: 'role/findAllRoles' });
      yield take('findAllRoles@@end');
      const { roleMenus = [] } = yield select(state => state.role);
      const roleMenu = roleMenus.find(
        roleMenu => roleMenu.id === userInfo.roleId
      );
      const { menus = [] } = roleMenu || {};
      const menu = menus.find(menu => {
        const path = `${PATH_HOME}${menu.url}`;
        if (path !== pathname && path.indexOf(pathname) > -1) {
          return menu;
        }
      });
      if (menu) {
        redirectPath = `${PATH_HOME}${menu.url}`;
      }
      yield put(routerRedux.replace(redirectPath));
    }
  },

  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname,search }) => {
        if (
          pathname !== PATH_HOME &&
          pathname !== PATHS.delayMeeting &&
          pathname.indexOf('/sysconfig') === -1 &&
          pathname !== PATHS.policy &&
          pathname !== PATHS.appIndex &&
          pathname !== PATHS.sysParam &&
          pathname !== PATHS.sysLog &&
          pathname !== PATHS.license &&
          pathname !== PATHS.test
        ) {
          dispatch({ type: 'getMenu', pathname: pathname });
          dispatch({ type: 'getMonitorServer'});
        }
        dispatch({ type: 'updatePathname', pathname });
        dispatch({ type: 'updateSearch', search });
      });
    }
  }
};

/**
 *  匹配当前用户的菜单和当前的路由
 *  返回值：
 *    valid：该路由是否有效(比如用户随便输入的错误路由就是无效的)
 *    forbidden: 用户是否禁止入内（用户所拥有的菜单决定能否进入）
 * */
const matchPath = (pathName, menus) => {
  const result = { valid: false, forbidden: true };
  if (
    pathName == PATHS.roomReportDetails ||
    pathName == PATHS.roomAbnormalDetail ||
    pathName == PATHS.userAbnormalDetail ||
    pathName.indexOf('meetingControl') > -1
  ) {
    result.forbidden = false;
  }
  for (let property in PATHS) {
    const pathReg = pathToRegexp(PATHS[property]);
    if (pathReg.test(pathName)) {
      result.valid = true;
    }
  }
  if (!result.valid) {
    return result;
  }
  if (!menus || menus.length === 0) {
    return result;
  }
  for (let menu of menus) {
    let { children: childMenus = [], url } = menu;
    url = `${PATH_HOME}${url}`;
    if (url === pathName) {
      result.forbidden = false;
      return result;
    }
    //特殊处理，如果有预约会议以及查看会议权限，就能进入预约界面
    if (
      (url === PATHS.meeting || url === PATHS.list) &&
      pathName === PATHS.meetingInfo
    ) {
      result.forbidden = false;
      return result;
    }
    for (let childMenu of childMenus) {
      let { url } = childMenu;
      url = `${PATH_HOME}${url}`;
      if (url === pathName) {
        result.forbidden = false;
        return result;
      }
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/models/menu.js